import { FC } from "react";
import Skeleton from "react-loading-skeleton";

interface SearchResultSkeletonProps {
    id: string | number;
    size?: "default" | "small";
    className?: string;
}

const SearchResultSkeleton: FC<SearchResultSkeletonProps> = (
    { id, size = "default", className="" }
) => {
  return (
    <div key={`search-result-skeleton-${id}`} id={`search-result-skeleton-${id}`} className={`search-result-skeleton ${size} group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow ${className}`}>
      <Skeleton height={size === "default" ? 300 : 200} />
    </div>
  );
};

export default SearchResultSkeleton;